module.exports = __webpack_public_path__ + "static/media/laptop-bottom.dc6017d4.svg";